export default "__VITE_ASSET__CQiRk7He__"